<template>
	<div>
		<div :id="'jsoneditor-' + id"></div>
	</div>
</template>

<script>
	import uniqueId from "lodash.uniqueid";
	import { JSONEditor } from "@json-editor/json-editor";

	import edit_tabulator from "../components/edit_tabulator.vue";

	import "../../public/js/ace-builds/src-min-noconflict/ace.js";

	export default {
		name: "document_extraction_zones",
		components: {
			edit_tabulator,
		},
		data() {
			return {
				id: uniqueId(""),
				editor: null,
				parameters: {},
				ready: false,
			};
		},
		methods: {
			async save() {
				var data = {
					parameters: this.parameters,
				};

				return data;
			},
			async load(data) {
				while (!this.ready) {
					await new Promise((resolve) => setTimeout(resolve, 100));
				}
				this.parameters = data.parameters;
				this.editor.setValue(this.parameters);
			},
		},
		mounted: async function () {
			var self = this;

			var schema = {
				title: "Type",
				type: "object",
				oneOf: [
					{
						title: "texte",
						required: ["type"],
						properties: {
							type: {
								title: "Type",
								type: "string",
								enum: ["texte"],
							},
						},
					},
					{
						title: "html",
						required: ["type"],
						properties: {
							type: {
								title: "Type",
								type: "string",
								enum: ["html"],
							},
						},
					},
					{
						title: "html complet",
						required: ["type"],
						properties: {
							type: {
								title: "Type",
								type: "string",
								enum: ["html complet"],
							},
						},
					},
					{
						title: "tableau",
						required: ["type", "method", "margin"],
						properties: {
							type: {
								title: "Type",
								type: "string",
								enum: ["tableau"],
							},
							method: {
								title: "Méthode",
								type: "string",
								enum: ["méthode 1", "méthode 2"],
							},
							margin: {
								title: "Marge",
								type: "number",
								default: 5,
								options: {
									hidden: true,
								},
							},
						},
					},
					{
						title: "tableau - méthode 2",
						required: ["type"],
						properties: {
							type: {
								title: "Type",
								type: "string",
								enum: ["tableau - méthode 2"],
							},
							config_cell: {
								title: "Type des cellules",
								type: "string",
								enum: ["texte", "html", "zones de texte"],
							},
							all_line: {
								title: "Toutes les cellules",
								type: "boolean",
								format: "checkbox",
							},
							align_top: {
								title: "Elargissement vertical",
								type: "string",
								enum: ["bas", "haut et bas"],
							},
							align_left: {
								title: "Elargissement horizontal",
								type: "string",
								enum: ["droite", "gauche et droite"],
							},
						},
					},
					{
						title: "zones de texte",
						required: ["type"],
						properties: {
							type: {
								title: "Type",
								type: "string",
								enum: ["zones de texte"],
							},
						},
					},
					{
						title: "Séquence",
						required: ["type"],
						properties: {
							type: {
								title: "Type",
								type: "string",
								enum: ["sequence"],
							},
							sequences: {
								title: "Séquences",
								type: "array",
								default: [[{}]],
								items: {
									title: "Séquence",
									type: "object",
									format: "categories",
									properties: {
										sequence: {
											title: "Séquence",
											format: "table",
											type: "array",
											default: [{}],
											items: {
												title: "Eléments",
												type: "object",
												properties: {
													type: {
														title: "Type",
														type: "string",
														enum: [
															"texte",
															"liste",
															"séquence",
															"regex",
															"nombre",
															"mots",
															"nombre décimal",
															"date (jour/mois/année)",
															"téléphone",
															"code postal",
														],
													},
													regex: {
														title: "Regex ou valeur",
														type: "string",
													},
													nb: {
														title: "Nombre d'occurences",
														type: "string",
														enum: [
															"un",
															"plusieurs",
														],
													},
													column: {
														title: "mapping",
														type: "string",
													},
													required: {
														title: "Obligatoire",
														type: "boolean",
														format: "checkbox",
													},
													temporary: {
														title: "Temporaire",
														type: "boolean",
														format: "checkbox",
													},
												},
											},
										},
										sequence_options: {
											title: "Séquence - options",
											format: "table",
											type: "array",
											default: [{}],
											items: {
												title: "Eléments",
												type: "object",
												properties: {
													column: {
														title: "mapping",
														type: "string",
													},
													max: {
														title: "Max",
														type: "boolean",
														format: "checkbox",
													},
													bold: {
														title: "Gras",
														type: "string",
														enum: ["oui", "non"],
														default: "",
													},
													italic: {
														title: "Italique",
														type: "string",
														enum: ["oui", "non"],
														default: "",
													},
													font_color: {
														title: "Couleur",
														type: "string",
														enum: ["même couleur"],
														default: "",
													},
													font_size: {
														title: "Taille",
														type: "string",
														default: "",
													},
												},
											},
										},
										options: {
											title: "Options",
											type: "object",
											properties: {
												name: {
													title: "Nom",
													type: "string",
												},
												column: {
													title: "Colonne",
													type: "string",
												},
												object: {
													title: "Objet",
													type: "boolean",
													format: "checkbox",
												},
												parent: {
													title: "Parent",
													type: "boolean",
													format: "checkbox",
												},
												strict: {
													title: "Strict",
													type: "boolean",
													format: "checkbox",
												},
												group_regex: {
													title: "Groupe de regex",
													type: "boolean",
													format: "checkbox",
												},
												separator: {
													title: "Séparateur",
													type: "string",
													default: " ",
												},
												meta_split: {
													title: "Séparer en fonction des styles",
													type: "boolean",
													format: "checkbox",
													default: false,
												},
											},
										},
									},
								},
							},
							end: {
								title: "Fin",
								type: "string",
								enum: ["", "fin de ligne"],
							},
							separator_line: {
								title: "Séparateur de fin de ligne",
								type: "string",
							},
							separator_block: {
								title: "Séparateur de zones de texte",
								type: "string",
							},
						},
					},
				],
			};

			const element = document.getElementById("jsoneditor-" + this.id);

			this.editor = new JSONEditor(element, {
				schema: schema,
				theme: "bootstrap4",
				iconlib: "fontawesome5",
				keep_oneof_values: false,
				object_background: "",
				prompt_before_delete: false,
				display_required_only: false,
			});

			await new Promise((resolve, reject) => {
				self.editor.on("ready", function () {
					self.ready = true;
					if (resolve) resolve();
				});
			});

			this.editor.on("change", function () {
				self.parameters = self.editor.getValue();
				self.$emit("update", {
					name: self.name,
					parameters: self.parameters,
				});
			});
		},
	};
</script>

<style></style>
